import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

/**
 * Web-only bookkeeping (conventions §15): which @tahi/db migrations this device has applied.
 * outbox and sync_state are device-only tables defined in @tahi/db and created by its migrations.
 */
export const localMigrations = sqliteTable('local_migrations', {
  name: text('name').primaryKey(),
  appliedAt: text('applied_at').notNull(),
});

export const LOCAL_MIGRATIONS_SQL =
  'CREATE TABLE IF NOT EXISTS local_migrations (name TEXT PRIMARY KEY NOT NULL, applied_at TEXT NOT NULL)';
